import Scrollbars from "react-custom-scrollbars-2"

export const ScrollView = Scrollbars;